"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const Legend = ({ children, style }) => {
    return (React.createElement("div", { style: Object.assign({ backgroundColor: colors_1.white, border: `1px solid ${colors_1.titanium}`, borderRadius: 3, width: 192, padding: 16 }, style) }, children));
};
exports.default = Legend;
